import Vue from 'vue';
import VueRouter from 'vue-router';
import multiguard from 'vue-router-multiguard';

import Home from '../views/Home.vue';
import GettingStarted from '../views/GettingStarted.vue';
// import Pricing from '../views/Pricing.vue';
// import Faq from '../views/Faq.vue';
import AboutUs from '../views/AboutUs.vue';

import PasswordReset from '../views/PasswordReset.vue';
import Dashboard from '../views/Dashboard.vue';
import Statistics from '../views/Statistics.vue';
import Gas from '../views/Gas.vue';
import Expenses from '../views/Expenses.vue';
import Reminders from '../views/Reminders.vue';
import Cars from '../views/Cars.vue';

import Settings from '../views/Settings.vue';
import { AUTH_TOKEN } from '../vue-apollo';


Vue.use(VueRouter);

/**
 * logged in guard, checks if user has auth token, otherwise redirects to login page
 *
 * @param to
 * @param from
 * @param next
 */
const isLoggedIn = (to, from, next) => {
  if (localStorage.getItem(AUTH_TOKEN)) {
    next();
  } else {
    next({ name: 'login' });
  }
};

/**
 * logged out guard
 *
 * @param to
 * @param from
 * @param next
 */
const isGuest = (to, from, next) => {
  if (localStorage.getItem(AUTH_TOKEN) != null) {
    next({ name: 'dashboard' });
  } else {
    next();
  }
};

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    beforeEnter: multiguard([isGuest]),
  },
  {
    path: '/password/reset/:token',
    name: 'password-reset',
    props: true,
    component: PasswordReset,
    beforeEnter: multiguard([isGuest]),
  },
  {
    path: '/getting-started',
    name: 'getting-started',
    props: true,
    component: GettingStarted,
  },
  // {
  //   path: '/pricing',
  //   name: 'pricing',
  //   props: true,
  //   component: Pricing,
  // },
  // {
  //   path: '/faq',
  //   name: 'faq',
  //   props: true,
  //   component: Faq,
  // },
  {
    path: '/about-us',
    name: 'about-us',
    props: true,
    component: AboutUs,
  },
  {
    path: '/password/reset/:token',
    name: 'password-reset',
    props: true,
    component: PasswordReset,
    beforeEnter: multiguard([isGuest]),
  },
  {
    path: '/password/reset/:token',
    name: 'password-reset',
    props: true,
    component: PasswordReset,
    beforeEnter: multiguard([isGuest]),
  },
  {
    path: '/password/reset/:token',
    name: 'password-reset',
    props: true,
    component: PasswordReset,
    beforeEnter: multiguard([isGuest]),
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   meta: { layout: 'dashboard' },
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  // },
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: { layout: 'dashboard' },
    component: Dashboard,
    beforeEnter: multiguard([isLoggedIn]),
  },
  {
    path: '/cars',
    name: 'cars',
    meta: { layout: 'dashboard' },
    component: Cars,
    beforeEnter: multiguard([isLoggedIn]),
  },
  {
    path: '/settings',
    name: 'settings',
    meta: { layout: 'dashboard' },
    component: Settings,
    beforeEnter: multiguard([isLoggedIn]),
  },
  {
    path: '/car/:id/statistics',
    props: true,
    name: 'statistics',
    meta: { layout: 'dashboard' },
    component: Statistics,
    beforeEnter: multiguard([isLoggedIn]),
  },
  {
    path: '/car/:id/gas',
    name: 'gas',
    meta: { layout: 'dashboard' },
    component: Gas,
    beforeEnter: multiguard([isLoggedIn]),
  },
  {
    path: '/car/:id/expenses',
    props: true,
    name: 'expenses',
    meta: { layout: 'dashboard' },
    component: Expenses,
    beforeEnter: multiguard([isLoggedIn]),
  },
  {
    path: '/car/:id/reminders',
    props: true,
    name: 'reminders',
    meta: { layout: 'dashboard' },
    component: Reminders,
    beforeEnter: multiguard([isLoggedIn]),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
